export const BROADCAST = 'Broadcast';

export const AVAILABLE_TOOLS = {
  // Teleprompter: 'Prompter',
  Broadcast: 'Studio'
};
